<template>
  <div class="homePage">
    <!-- 第一页 -->
    <div class="section active">
      <!-- 全屏背景图 -->
      <div class="img-box">
        <hoverShowVideo ref="hoverShowVideo" videoOrGif="gif" />
      </div>
      <!-- 全屏背景图 -->

      <!-- 欢迎语 -->
      <div class="welcome-box positionCenter">
        <welcomeBox ref="welcomeBox" />
      </div>
      <!-- 欢迎语 -->

      <!-- 导航栏 -->
      <div :class="isCollapse ? 'menu-box-collapse' : 'menu-box'">
        <menuBox ref="menuBox" :isCollapse="isCollapse" />
      </div>
      <!-- 导航栏 -->
    </div>
    <!-- 第一页 -->

    <!-- 第二页 -->
    <!-- 项目经历 -->
    <div class="section">
      <projectBox ref="projectBox" />
    </div>
    <!-- 项目经历 -->
    <!-- 第二页 -->

    <!-- 第三页 -->
    <div class="section fp-auto-height">
      <!-- 开源项目 -->
      <div class="open-box">
        <openBox ref="openBox" />
      </div>
      <!-- 开源项目 -->
    </div>
    <!-- 第三页 -->

    <!-- 第四页 -->
    <!-- 友链 -->
    <div class="section fp-auto-height">
      <friendlyLink ref="friendlyLink" />
    </div>
    <!-- 友链 -->
    <!-- 第四页 -->

    <!-- 输入密码的弹窗 -->
    <passwordDialog ref="passwordDialog" />
    <!-- 输入密码的弹窗 -->

    <!-- 快速回到顶部 -->
    <!-- 快速回到顶部 -->
  </div>
</template>

<script>
import { makePassword, checkPassword } from "@/utils/password";
import passwordDialog from "@/views/homePage/passwordDialog";
import menuBox from "@/views/homePage/menuBox";
import projectBox from "@/views/homePage/projectBox";
import friendlyLink from "@/views/homePage/friendlyLink";
import openBox from "@/views/homePage/openBox";
import { mapActions } from "vuex";

export default {
  components: { passwordDialog, menuBox, projectBox, friendlyLink, openBox },
  data() {
    return {
      isCollapse: true,
    };
  },
  computed: {
    permissionArr() {
      return this.$store.state.permission.permissionArr;
    },
  },
  methods: {
    ...mapActions(["ADD_PASSWORD"]),

    handleScroll(e) {
      /* 如果密码弹窗已经打开了的话就不重复打开 */
      if (this.$refs.passwordDialog.dialogVisible) return;
      if (
        this.$store.state.auth.permission.id === 1 ||
        !localStorage.getItem("permission")
      ) {
        this.$refs.passwordDialog.showDialog();
      }
    },

    setPassword() {
      this.ADD_PASSWORD(makePassword());
    },

    changeIsCollapse() {
      this.isCollapse = !this.isCollapse;
    },

    initFullPage() {
      let that = this;
      new fullpage(".homePage", {
        autoScrolling: true,
        scrollHorizontally: true,
        recordHistory: false,
        anchors: [
          "index?page=1",
          "index?page=2",
          "index?page=3",
          "index?page=4",
        ],
        sectionsColor: [null, null, null, null], // 设置每个section背景颜色
        easingcss3: "cubic-bezier(0.175, 0.885, 0.320, 1.275)",
        controlArrows: false, // slide 时，左右两侧的切换按钮
        // controlArrowsHTML: [
        //   '<div class="my-arrow"><i class="iconfont icon-xiangzuo"></i></i></div>',
        //   '<div class="my-arrow"><i class="iconfont icon-xiangyou"></i></div>',
        // ],
        slidesNavigation: true, // slide 时，底部的小圆点
        normalScrollElements: ".full-page-exclude",
        onLeave: function (origin, destination, direction) {
          that.handleScroll();
        },
        onSlideLeave(section, origin, destination, direction, trigger) {
          that.$refs.projectBox.updateChooseFlag(destination.index);
        },
      });
    },

    destroyFullPage() {
      fullpage_api.destroy("all");
    },

    moveTo(page, num) {
      fullpage_api.moveTo(page, num);
    },

    initPermission() {
      let per = localStorage.getItem("permission");
      if (per) {
        this.$store.dispatch(
          "ADD_PERMISSION",
          this.permissionArr.filter((item) => item.localSet === per)[0]
        );
      }
    },
  },

  created() {
    this.initPermission();
    this.setPassword();
  },

  mounted() {
    console.warn("%c联系我:mhf.work@qq.com", "font-size:18px;color:red;");
    console.error("请勿在此输入非法内容！");
    this.initFullPage();
  },

  destroyed() {
    this.destroyFullPage();
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  .img-box {
  }

  .welcome-box {
    max-width: 40%;
    height: 100px;
  }

  .menu-box {
    width: 200px;
    /*border: 1px solid red;*/
    position: absolute;
    top: 20px;
    left: 20px;
  }

  .menu-box-collapse {
    width: 30px;
    /*border: 1px solid blue;*/
    position: absolute;
    top: 20px;
    left: 20px;
    padding: 0 6px 0 0;
    overflow: hidden;
  }

  .open-box {
  }
}

::v-deep .my-arrow i {
  font-size: 40px;
  /*color: red !important;*/
}
</style>
